export class FinancialAccountCashierManagement {
    accountCode: string;
    branchCode: string;
    companyName: string;
    financialAccountId: string;

    constructor() {
        this.accountCode = '';
        this.branchCode = '';
        this.companyName = '';
        this.financialAccountId = '';
    }
}
